module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-42-cf5fbd59ded807da4f6f0d6a9087b1e0.svg";